import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  IconButton,
  Tabs,
  Tab,
} from "@mui/material";

import Iconify from "../components/iconify";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { createBlobInContainer } from "src/utils/filesApi";
import EditTextSettings from "src/components/bingo/EditTextSettings";

const getCardFormatQuestionsCount = (cardFormat) => {
  switch (cardFormat) {
    case "three_on_five":
      return 15;
    case "five_on_five":
      return 25;
    default:
      return 15;
  }
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}

const dateFormat = "YYYY-MM-DD HH:mm:ss";
export default function GameEditPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [game, setGame] = useState(null);
  const [tenants, setTenants] = useState(null);
  const [questionsCountErrorMessage, setQuestionsCountErrorMessage] =
    useState(null);
  const [questionsTypeCountErrorMessage, setQuestionsTypeCountErrorMessage] =
    useState(null);
  const [value, setValue] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();
  const [state, setState] = useState({
    name: "",
    titleEn: "",
    titleFr: "",
    kickoff: "",
    cardFormat: "three_on_five",
    easyQuestionsCount: 0,
    mediumQuestionsCount: 0,
    hardQuestionsCount: 0,
    teamQuestionsCount: 0,
    playerQuestionsCount: 0,
    status: "DRAFT",
    IsChekinAllowed: false,
  });

  useEffect(() => {
    if (searchParams.has("game_id")) {
      let gameId = searchParams.get("game_id");
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/games`)
        .then(function (response) {
          let editGame = response.data.games.find(
            (item) => item.gameId === +gameId
          );
          setGame(editGame);
          setState((prevState) => ({
            ...prevState,
            ...editGame,
          }));
        });
    } else {
      //navigate("/404");
    }
    axios
      .get(
        `${process.env.REACT_APP_CLIENTS_API_BASE_URL}/clients/${process.env.REACT_APP_CLIENT_CODE}/tenants`
      )
      .then(function (response) {
        if (response.data?.tenants) {
          setTenants(response.data.tenants);
        }
      });
    setLoading(false);
  }, []);

  // Validate questions count sum
  useEffect(() => {
    let allQuestionsCount =
      parseInt(state.easyQuestionsCount) +
      parseInt(state.mediumQuestionsCount) +
      parseInt(state.hardQuestionsCount);
    let expectedQuestionsCount = getCardFormatQuestionsCount(state.cardFormat);
    if (allQuestionsCount !== expectedQuestionsCount) {
      setQuestionsCountErrorMessage(
        `Number is not valid: Allowed sum for questions count ${expectedQuestionsCount}`
      );
    } else {
      setQuestionsCountErrorMessage(null);
    }

    let allTypesQuestionsCount =
      parseInt(state.teamQuestionsCount) + parseInt(state.playerQuestionsCount);
    if (allTypesQuestionsCount !== expectedQuestionsCount) {
      setQuestionsTypeCountErrorMessage(
        `Number is not valid: Allowed sum for questions count ${expectedQuestionsCount}`
      );
    } else {
      setQuestionsTypeCountErrorMessage(null);
    }
  }, [state]);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCardFormatChange = (e) => {
    setState((prevState) => ({
      ...prevState,
      cardFormat: e.target.value,
    }));
  };

  const deleteImage = (key) => {
    setState((prevState) => ({
      ...prevState,
      [key]: null,
    }));
  };

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeCheckIn = (e) => {
    setState((prevState) => ({
      ...prevState,
      isChekinAllowed: e.target.checked,
    }));
  };
  const handleChangeShowCards = (e) => {
    setState((prevState) => ({
      ...prevState,
      showCards: e.target.checked,
    }));
  };
  const handleSubmitClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/game/${game.gameId}/edit`,
        state
      )
      .then((response) => {
        window.location.reload();
      });
  };
  const handleChangeStatus = (event) => {
    setState((prevState) => ({
      ...prevState,
      status: event.target.value,
    }));
  };
  const handleChangeTenant = (event) => {
    setState((prevState) => ({
      ...prevState,
      tenant: event.target.value === "" ? null : event.target.value,
    }));
  };

  const uploadFiles = (event, name) => {
    if (event.target.files.length > 0) {
      const files = event.target.files;
      console.log("name", name);
      let uploadPromises = [];
      uploadPromises.push(createBlobInContainer(files[0]));

      if (uploadPromises.length > 0) {
        const uploadFiles = async () => {
          const url = await Promise.all(uploadPromises);

          setState((prevState) => ({
            ...prevState,
            [name]: url[0],
          }));
        };

        uploadFiles().catch(console.error);
      }
    }
  };

  const handleDateChange = (newValue, fieldName) => {
    //console.log(newValue, moment(newValue).format(dateFormat));
    setState((prevState) => ({
      ...prevState,
      [fieldName]: moment(newValue).format(dateFormat), //2022-11-23 23:00:00
    }));
  };

  //TODO: disable CardFormat update on generated cards
  return (
    <>
      <Helmet>
        <title> Bingo Games Edit </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Bingo Game Edit
          </Typography>

          <Box>
            <Button
              variant="outlined"
              startIcon={<Iconify icon="eva:close-outline" />}
              onClick={() => navigate(`/dashboard/games`)}
              sx={{ mr: 2 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:save-outline" />}
              onClick={handleSubmitClick}
              disabled={
                questionsCountErrorMessage !== null ||
                questionsTypeCountErrorMessage !== null
              }
            >
              Save
            </Button>
          </Box>
        </Stack>

        <Card sx={{ padding: 4, margin: 1 }}>
          {game === null ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <InputLabel id="status-select-label">Type</InputLabel>
                    <Select
                      labelId="status-label"
                      id="status-select"
                      value={state.status ?? "DRAFT"}
                      label="Type"
                      onChange={handleChangeStatus}
                    >
                      <MenuItem value="DRAFT">DRAFT</MenuItem>
                      <MenuItem value="UPCOMING">UPCOMING</MenuItem>
                      <MenuItem value="IN_PLAY">IN_PLAY</MenuItem>
                      <MenuItem value="COMPLETED">COMPLETED</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.isChekinAllowed}
                        onChange={handleChangeCheckIn}
                        id="isChekinAllowed"
                      />
                    }
                    label="Allow Game CheckIn"
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.showCards}
                        onChange={handleChangeShowCards}
                        id="showCards"
                      />
                    }
                    label="Show Cards"
                  />
                </Grid>
                {process.env.REACT_APP_ENABLE_TENANT === "true" &&
                  tenants !== null && (
                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <InputLabel id="status-select-label">Tenant</InputLabel>
                        <Select
                          labelId="status-label"
                          id="status-select"
                          value={state.tenant ?? ""}
                          label="Type"
                          onChange={handleChangeTenant}
                        >
                          <MenuItem value="">None</MenuItem>
                          {tenants.map((row, index) => (
                            <MenuItem value={row.prefix}>{row.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}

                <Grid item xs={12}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                      label="Show cards UTC"
                      value={moment(state.kickoff, dateFormat)}
                      onChange={(value) => handleDateChange(value, "kickoff")}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                      label="CheckIn Start UTC"
                      value={moment(state.allowCheckInStartUtc, dateFormat)}
                      onChange={(value) =>
                        handleDateChange(value, "allowCheckInStartUtc")
                      }
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                      label="CheckIn End UTC"
                      value={moment(state.allowCheckInEndUtc, dateFormat)}
                      onChange={(value) =>
                        handleDateChange(value, "allowCheckInEndUtc")
                      }
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                      label="Generate Cards Start UTC"
                      value={moment(state.generateCardStartUtc, dateFormat)}
                      onChange={(value) =>
                        handleDateChange(value, "generateCardStartUtc")
                      }
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                      label="Generate Cards End UTC"
                      value={moment(state.generateCardEndUtc, dateFormat)}
                      onChange={(value) =>
                        handleDateChange(value, "generateCardEndUtc")
                      }
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item xs={2}>
                      <FormLabel id="card-format-label">Card Format</FormLabel>
                      <RadioGroup
                        aria-labelledby="card-format-label"
                        defaultValue={state.cardFormat}
                        name="radio-buttons-group"
                        onChange={handleCardFormatChange}
                      >
                        <FormControlLabel
                          value="three_on_five"
                          control={<Radio />}
                          label="3X5"
                        />
                        <FormControlLabel
                          value="five_on_five"
                          control={<Radio />}
                          label="5X5"
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid item xs={10}>
                      <FormLabel id="card-format-label">
                        Questions Settings
                      </FormLabel>

                      <Grid container spacing={2}>
                        <Grid item xs={2}>
                          <TextField
                            error={questionsCountErrorMessage !== null}
                            helperText={questionsCountErrorMessage}
                            label="Easy Questions #"
                            id="easyQuestionsCount"
                            variant="standard"
                            value={state.easyQuestionsCount}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          {" "}
                          <TextField
                            error={questionsCountErrorMessage !== null}
                            helperText={questionsCountErrorMessage}
                            label="Medium Questions #"
                            id="mediumQuestionsCount"
                            variant="standard"
                            value={state.mediumQuestionsCount}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <TextField
                            error={questionsCountErrorMessage !== null}
                            helperText={questionsCountErrorMessage}
                            label="Hard Questions #"
                            id="hardQuestionsCount"
                            variant="standard"
                            value={state.hardQuestionsCount}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <TextField
                            error={questionsTypeCountErrorMessage !== null}
                            helperText={questionsTypeCountErrorMessage}
                            label="Team Questions #"
                            id="teamQuestionsCount"
                            variant="standard"
                            value={state.teamQuestionsCount}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <TextField
                            error={questionsTypeCountErrorMessage !== null}
                            helperText={questionsTypeCountErrorMessage}
                            label="Player Questions #"
                            id="playerQuestionsCount"
                            variant="standard"
                            value={state.playerQuestionsCount}
                            onChange={handleChange}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12}>
                  <FormLabel id="card-format-label">Game Style</FormLabel>
                  <Grid container spacing={2}>
                    <Grid item xs={2}>
                      {" "}
                      <TextField
                        label="Tile Color"
                        id="tileColor"
                        variant="standard"
                        value={state.tileColor}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="Active Cell Color"
                        id="activeCellColor"
                        variant="standard"
                        value={state.activeCellColor}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="Primary Color"
                        id="primaryColor"
                        variant="standard"
                        value={state.primaryColor}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="Entries BG Color"
                        id="entriesBgColor"
                        variant="standard"
                        value={state.entriesBgColor}
                        onChange={handleChange}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel id="card-format-label">Event Image</FormLabel>
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(event) => uploadFiles(event, "eventImage")}
                    />
                    <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
                  </IconButton>
                  {state.eventImage ? (
                    <img
                      style={{
                        margin: "0 auto",
                        width: 100,
                        background: "grey",
                      }}
                      alt="Image"
                      src={state.eventImage}
                    />
                  ) : null}
                </Grid>
                <Grid item xs={2}>
                  <FormLabel id="card-format-label">Bonus Cell Image</FormLabel>
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(event) => uploadFiles(event, "bonusCellImage")}
                    />
                    <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
                  </IconButton>
                  {state.bonusCellImage ? (
                    <img
                      style={{
                        margin: "0 auto",
                        width: 100,
                        background: "grey",
                      }}
                      alt="Image"
                      src={state.bonusCellImage}
                    />
                  ) : null}
                </Grid>
                <Grid item xs={2}>
                  <FormLabel id="card-format-label">Sponsor Image</FormLabel>
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(event) => uploadFiles(event, "sponsorImage")}
                    />
                    <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
                  </IconButton>
                  {state.sponsorImage ? (
                    <img
                      style={{
                        margin: "0 auto",
                        width: 100,
                        background: "grey",
                      }}
                      alt="Image"
                      src={state.sponsorImage}
                    />
                  ) : null}
                </Grid>
                <Grid item xs={2}>
                  <FormLabel id="card-format-label">BINGO Image</FormLabel>
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(event) => uploadFiles(event, "bingoImage")}
                    />
                    <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
                  </IconButton>
                  {state.bingoImage ? (
                    <img
                      style={{
                        margin: "0 auto",
                        width: 100,
                        background: "grey",
                      }}
                      alt="Image"
                      src={state.bingoImage}
                    />
                  ) : null}
                </Grid>
                <Grid item xs={4}>
                  <FormLabel id="card-format-label">Background Image</FormLabel>
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(event) => uploadFiles(event, "tileBgImage")}
                    />
                    <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
                  </IconButton>
                  {state.tileBgImage ? (
                    <img
                      style={{
                        margin: "0 auto",
                        width: 100,
                        background: "grey",
                      }}
                      alt="Image"
                      src={state.tileBgImage}
                    />
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  <FormLabel id="card-format-label">Card Top Image</FormLabel>
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(event) => uploadFiles(event, "cardTopImage")}
                    />
                    <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
                  </IconButton>
                  {state.cardTopImage ? (
                    <img
                      style={{
                        margin: "0 auto",
                        width: 500,
                        background: "grey",
                      }}
                      alt="Image"
                      src={state.cardTopImage}
                    />
                  ) : null}
                </Grid>
                {/* <Grid item xs={12}>
                  <TextField
                    label="Prize Text"
                    id="prizeText"
                    variant="standard"
                    value={state.prizeText}
                    onChange={handleChange}
                    multiline
                    rows={6}
                    sx={{ width: 600, mb: 3 }}
                    maxRows={6}
                  />
                </Grid> */}
              </Grid>
            </>
          )}
        </Card>
        {game === null ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Box>
              <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={value}
                    onChange={handleChangeTabs}
                    aria-label="basic tabs example"
                  >
                    <Tab label="English" {...a11yProps(0)} />
                    <Tab label="French" {...a11yProps(1)} />
                    <Tab label="Slovak" {...a11yProps(2)} />
                    <Tab label="Estonian" {...a11yProps(3)} />
                    <Tab label="Latvian" {...a11yProps(4)} />
                    <Tab label="Lithuanian" {...a11yProps(5)} />
                    <Tab label="Russian" {...a11yProps(6)} />
                    <Tab label="Spanish" {...a11yProps(7)} />
                    <Tab label="German" {...a11yProps(8)} />
                  </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                  <EditTextSettings
                    loading={loading}
                    state={state}
                    lang="En"
                    deleteImage={deleteImage}
                    handleChange={handleChange}
                    uploadFiles={uploadFiles}
                  />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <EditTextSettings
                    loading={loading}
                    state={state}
                    lang="Fr"
                    deleteImage={deleteImage}
                    handleChange={handleChange}
                    uploadFiles={uploadFiles}
                  />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <EditTextSettings
                    loading={loading}
                    state={state}
                    lang="Sl"
                    deleteImage={deleteImage}
                    handleChange={handleChange}
                    uploadFiles={uploadFiles}
                  />
                </TabPanel>
                <TabPanel value={value} index={3}>
                  <EditTextSettings
                    loading={loading}
                    state={state}
                    lang="Es"
                    deleteImage={deleteImage}
                    handleChange={handleChange}
                    uploadFiles={uploadFiles}
                  />
                </TabPanel>
                <TabPanel value={value} index={4}>
                  <EditTextSettings
                    loading={loading}
                    state={state}
                    lang="Lv"
                    deleteImage={deleteImage}
                    handleChange={handleChange}
                    uploadFiles={uploadFiles}
                  />
                </TabPanel>
                <TabPanel value={value} index={5}>
                  <EditTextSettings
                    loading={loading}
                    state={state}
                    lang="Lt"
                    deleteImage={deleteImage}
                    handleChange={handleChange}
                    uploadFiles={uploadFiles}
                  />
                </TabPanel>
                <TabPanel value={value} index={6}>
                  <EditTextSettings
                    loading={loading}
                    state={state}
                    lang="Rus"
                    deleteImage={deleteImage}
                    handleChange={handleChange}
                    uploadFiles={uploadFiles}
                  />
                </TabPanel>
                <TabPanel value={value} index={7}>
                  <EditTextSettings
                    loading={loading}
                    state={state}
                    lang="Esp"
                    deleteImage={deleteImage}
                    handleChange={handleChange}
                    uploadFiles={uploadFiles}
                  />
                </TabPanel>
                <TabPanel value={value} index={8}>
                  <EditTextSettings
                    loading={loading}
                    state={state}
                    lang="De"
                    deleteImage={deleteImage}
                    handleChange={handleChange}
                    uploadFiles={uploadFiles}
                  />
                </TabPanel>
              </Box>
            </Box>
          </>
        )}
      </Container>
    </>
  );
}
